export type { MessageBarTitleSlots, MessageBarTitleProps, MessageBarTitleState } from '@fluentui/react-message-bar';
